import { Button, Modal } from "react-bootstrap";

const AvailabilityExplainModal = ({
  show,
  onHide,
}: {
  show: boolean;
  onHide: () => void;
}) => (
  <Modal show={show} onHide={onHide} centered size="lg">
    <Modal.Header closeButton>
      <Modal.Title>PV System Availability</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        PV system availability measures what proportion of expected generation
        time the system was actually operational.
      </p>
      <p>
        <strong>
          availability = 1 &minus; (unavailable periods / expected generation
          periods)
        </strong>
      </p>
      <p>
        <strong>Expected generation periods</strong> are determined from the
        site&apos;s P50 generation forecast, which originates from hourly PVGIS
        Typical Meteorological Year (TMY) data for the site&apos;s location. To
        smooth out day-to-day TMY variation, each day&apos;s expected generation
        profile is computed as the median of a rolling 7-day window of
        neighbouring days&apos; forecasts.
      </p>
      <p>
        Hours where the smoothed forecast exceeds a capacity-scaled threshold (1
        kWh per 100 kWp of installed capacity) are considered expected
        generation hours &mdash; hours below this threshold are too low to
        reliably expect generation. For each day&apos;s first expected
        generation hour, only the last measurement period within that hour is
        counted (e.g. the last 30 minutes for a half-hourly site, or the last 15
        minutes for a quarter-hourly site), since the system may still be
        ramping up. The same applies in reverse for the last expected generation
        hour of each day &mdash; only the first measurement period is counted.
        All other expected generation hours are counted at the site&apos;s full
        measurement resolution.
      </p>
      <p>
        <strong>Unavailable periods</strong> are the total duration of
        &ldquo;zero generation&rdquo; health events that are classified as an{" "}
        <em>unplanned PV outage</em>. Events classified as{" "}
        <em>unplanned battery outage</em>, <em>planned</em> (e.g. scheduled
        maintenance), <em>transient</em> (auto-resolved), or <em>ignore</em>{" "}
        are excluded from the calculation. For sites with
        multiple energy matches, zero generation is detected independently
        per energy match and the unavailable time ranges are combined
        (unioned) for the site&apos;s overall availability.
      </p>
      <p className="text-muted small mb-0">
        &ldquo;Last month&rdquo; covers the previous complete calendar month.
        &ldquo;Last 12 months&rdquo; covers the trailing 12 complete calendar
        months.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);

export default AvailabilityExplainModal;
